import { TZDate } from '@date-fns/tz';
import { useCallback, useEffect, useState } from 'react';

type CurrentTimeOutput = {
  currentTime: Date;
  updateCurrentTime: () => void;
};

export const useCurrentTime = (intervalMs = 5000): CurrentTimeOutput => {
  const [currentTime, setCurrentTime] = useState<Date>(new TZDate(new Date(), 'Europe/Vienna'));

  const updateCurrentTime = useCallback(() => {
    setCurrentTime(new TZDate(new Date(), 'Europe/Vienna'));
  }, []);

  useEffect(() => {
    const updateInterval = setInterval(updateCurrentTime, intervalMs);
    return () => clearInterval(updateInterval);
  }, [intervalMs, updateCurrentTime]);

  return { currentTime, updateCurrentTime };
};
